import React, { useState, useEffect } from 'react';
import {
  Card,
  Button,
  Alert,
  Statistic,
  Row,
  Col,
  Typography,
  Divider,
  message,
  Table,
  Space,
  Tag
} from 'antd';
import {
  DatabaseOutlined,
  ReloadOutlined
} from '@ant-design/icons';
import devToolsService from '../services/devToolsService.ts';

const { Title, Text } = Typography;

const DevTools: React.FC = () => {
  const [databaseStatus, setDatabaseStatus] = useState<any>(null);

  useEffect(() => {
    loadDatabaseStatus();
  }, []);

  const loadDatabaseStatus = async () => {
    try {
      const status = await devToolsService.getDatabaseStatus();
      setDatabaseStatus(status);
    } catch (error) {
      console.error('Errore nel caricamento dello stato database:', error);
      message.error('Errore nel caricamento dello stato database');
    }
  };

  const getDatabaseStatusTable = () => {
    if (!databaseStatus) return [];

    return Object.entries(databaseStatus.database_status).map(([table, count]) => ({
      key: table,
      table: table,
      records: count,
      status: typeof count === 'number' ? (count > 0 ? 'has-data' : 'empty') : 'error'
    }));
  };

  const columns = [
    {
      title: 'Tabella',
      dataIndex: 'table',
      key: 'table',
      render: (text: string) => <Text code>{text}</Text>
    },
    {
      title: 'Record',
      dataIndex: 'records',
      key: 'records',
      render: (count: any) => {
        if (typeof count === 'number') {
          return (
            <Tag color={count > 0 ? 'blue' : 'green'}>
              {count.toLocaleString()}
            </Tag>
          );
        }
        return <Tag color="red">Errore</Tag>;
      }
    },
    {
      title: 'Stato',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => {
        const statusConfig = {
          'has-data': { color: 'blue', text: 'Contiene dati' },
          'empty': { color: 'green', text: 'Vuota' },
          'error': { color: 'red', text: 'Errore' }
        };
        const config = statusConfig[status as keyof typeof statusConfig];
        return <Tag color={config.color}>{config.text}</Tag>;
      }
    }
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <Title level={2}>
          <DatabaseOutlined /> Strumenti di Sviluppo
        </Title>

        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Card title="Stato Database" size="small">
              {databaseStatus && (
                <Space direction="vertical" style={{ width: '100%' }}>
                  <Statistic
                    title="Totale Record Transazionali"
                    value={databaseStatus.total_transactional_records}
                    prefix={<DatabaseOutlined />}
                  />
                  <Button
                    icon={<ReloadOutlined />}
                    onClick={loadDatabaseStatus}
                    size="small"
                  >
                    Aggiorna Stato
                  </Button>
                </Space>
              )}
            </Card>
          </Col>
        </Row>

        <Divider />

        <Title level={4}>Dettaglio Tabelle</Title>
        <Table
          columns={columns}
          dataSource={getDatabaseStatusTable()}
          size="small"
          pagination={false}
          loading={!databaseStatus}
        />
      </Card>
    </div>
  );
};

export default DevTools;
